var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcBusiness = function SvgIcBusiness(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3474_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3416 5.66233L1.64575 8.72754L5.49189 42.2247L32.1877 39.1595L28.3416 5.66233Z",
    fill: "#012A56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5573 14.9402V42.3382H5.64307V7.31372H25.9291L33.5573 14.9402Z",
    fill: "#004C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5572 14.9402H25.929V7.31372L33.5572 14.9402Z",
    fill: "#049DDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1117 19.5799L7.40649 29.2852L10.8936 32.7723L20.5988 23.067L17.1117 19.5799Z",
    fill: "#049DDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9023 17.8415L15.3711 21.2839L25.8143 31.9967L29.3455 28.5543L18.9023 17.8415Z",
    fill: "#FCD647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3114 12.7284L23.6738 29.8264L27.1051 33.366L44.7427 16.268L41.3114 12.7284Z",
    fill: "#07F184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9744 11.0308H46.3516V19.408L37.9744 11.0308Z",
    fill: "#07F184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2786 21.3593L18.8556 24.917L22.4028 21.3698L18.9081 17.8015L15.2786 21.3593Z",
    fill: "#FF5347"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3474_620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcBusiness);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ic-business.e9e09a470a8551728d349ae96c06be2d.svg";